import { useEffect, useState } from "react";
import { clearUserImages, fetchImagesByDate, getFileUrl } from "../api";

export function RecordsView() {
  const [dates, setDates] = useState<string[]>([]);
  const [selectedDate, setSelectedDate] = useState<string | "">("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [imagesByUploader, setImagesByUploader] = useState<
    Record<
      string,
      { originalFilename: string; storedFilename: string; uploadDate: string }[]
    >
  >({});
  const [previewSrc, setPreviewSrc] = useState<string | null>(null);
  const [previewTitle, setPreviewTitle] = useState<string>("");

  const loadData = async (date?: string) => {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchImagesByDate(date);
      setDates(data.dates);
      setSelectedDate(data.selectedDate ?? "");
      const mapped: typeof imagesByUploader = {};
      Object.entries(data.images).forEach(([uploader, list]) => {
        mapped[uploader] = list.map((item) => ({
          originalFilename: item.originalFilename,
          storedFilename: item.storedFilename,
          uploadDate: item.uploadDate
        }));
      });
      setImagesByUploader(mapped);
    } catch (err) {
      setError(err instanceof Error ? err.message : "加载失败");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void loadData();
  }, []);

  const handleDateChange = (value: string) => {
    setSelectedDate(value);
    void loadData(value || undefined);
  };

  const handleClearUser = async (uploader: string) => {
    if (!selectedDate) {
      window.alert("请先在上方选择具体日期，再删除某人的当日图片。");
      return;
    }
    const confirmed = window.confirm(
      `确认删除 ${uploader} 在 ${selectedDate} 的所有图片吗？此操作不可恢复。`
    );
    if (!confirmed) return;

    try {
      setLoading(true);
      setError(null);
      const res = await clearUserImages(uploader, selectedDate);
      window.alert(
        res.removed > 0
          ? `已删除 ${uploader} 在 ${selectedDate} 的 ${res.removed} 张图片。`
          : `${uploader} 在 ${selectedDate} 没有可删除的图片。`
      );
      await loadData(selectedDate);
    } catch (err) {
      setError(err instanceof Error ? err.message : "删除失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="panel">
      <h2>查看上传记录</h2>
      <div className="field inline">
        <label>日期</label>
        <select
          value={selectedDate}
          onChange={(e) => handleDateChange(e.target.value)}
        >
          <option value="">全部</option>
          {dates.map((date) => (
            <option key={date} value={date}>
              {date}
            </option>
          ))}
        </select>
      </div>
      {loading && <p>加载中...</p>}
      {error && <p className="error">{error}</p>}
      {!loading && !error && (
        <div className="records-list">
          {Object.entries(imagesByUploader).map(([uploader, images]) => (
            <section key={uploader} className="uploader-block">
              <div className="uploader-header">
                <h3>{uploader}</h3>
                <div className="uploader-actions">
                  <span>共 {images.length} 张</span>
                  <button
                    type="button"
                    className="chip-button danger"
                    onClick={() => void handleClearUser(uploader)}
                  >
                    删除当日
                  </button>
                </div>
              </div>
              <div className="thumb-grid">
                {images.map((img, index) => (
                  <div
                    className="thumb"
                    key={`${img.storedFilename}-${index}`}
                  >
                    <div className="thumb-image-wrapper">
                      <img
                        src={getFileUrl(img.storedFilename)}
                        alt={img.originalFilename}
                        loading="lazy"
                        onClick={() => {
                          setPreviewSrc(getFileUrl(img.storedFilename));
                          setPreviewTitle(img.originalFilename);
                        }}
                        onError={(e) => {
                          // 图片加载失败时显示占位符
                          const target = e.target as HTMLImageElement;
                          target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="150" height="150"%3E%3Crect fill="%23e5e7eb" width="150" height="150"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%239ca3af" font-size="14"%3E加载失败%3C/text%3E%3C/svg%3E';
                        }}
                      />
                    </div>
                    <span title={img.originalFilename}>
                      {img.originalFilename}
                    </span>
                    <small>{img.uploadDate}</small>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      )}

      {previewSrc && (
        <div
          className="image-lightbox"
          onClick={() => {
            setPreviewSrc(null);
            setPreviewTitle("");
          }}
        >
          <div className="image-lightbox-inner">
            <img src={previewSrc} alt={previewTitle} />
            <p>{previewTitle}</p>
            <span className="image-lightbox-tip">轻触空白处关闭</span>
          </div>
        </div>
      )}
    </section>
  );
}

